/**
 * Shared ARAM heal / regen ratios (SPY-120 → SPY-220).
 * Kept free of maps/aramRules imports to avoid cycles.
 */

/** Relic pad heal/mana restore ratio (max resource). */
export const ARAM_RELIC_HEAL_RATIO = 0.47;

/**
 * Pickup radius in sandbox units — matches visual pad disc (~1.15).
 * Prior 40 let players scoop relics from far off the pad.
 */
export const ARAM_RELIC_PICKUP_RADIUS = 1.15;

/** Ally splash heal radius — same pad footprint as pickup. */
export const ARAM_RELIC_ALLY_HEAL_RADIUS = 1.15;

/** Out-of-combat ARAM aura HP regen per second (fraction of max HP). */
export const ARAM_OOC_HP_REGEN_RATIO = 0.00075;
